/* 🤖 this file was generated by svg-to-ts */
export const mgcIconTentFilled: {
  name: 'tent-filled';
  data: string;
} = {
  name: 'tent-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.643 4.069c-.097.034-.25.136-.34.227-.148.149-.437.803-3.219 7.299-2.196 5.126-3.062 7.189-3.075 7.326-.042.44.258.893.675 1.016.181.054.563.063 2.763.063H8l.002-2.59c.001-2.059.012-2.621.055-2.74a.998.998 0 0 1 1.643-.372c.308.308.3.224.3 3.129V20h5.553c4.923 0 5.576-.007 5.763-.063.417-.123.717-.576.675-1.016-.013-.137-.879-2.2-3.075-7.326-2.777-6.483-3.071-7.15-3.219-7.299-.306-.309-.153-.296-3.714-.293-2.757.003-3.186.011-3.34.066"/></svg>`
};
